import AttachProvidersTab from "./AttachProvidersTab";
import ScanDetailsTab from "./ScanDetailsTab";
import ScopeTab from "./ScopeTab";
import { ScanDetailsDrawerItem, ScanDetailsDrawerTab } from "./types";

type ScanDetailsDrawerTabContentProps = {
  scan: ScanDetailsDrawerItem;
  tab: ScanDetailsDrawerTab;
  onOpenFullDescription: () => void;
};

const ScanDetailsDrawerTabContent = ({
  scan,
  tab,
  onOpenFullDescription,
}: ScanDetailsDrawerTabContentProps) => {
  switch (tab) {
    case ScanDetailsDrawerTab.ScanDetails:
      return <ScanDetailsTab scan={scan} onOpenFullDescription={onOpenFullDescription} />;

    case ScanDetailsDrawerTab.AttachProviders:
      return <AttachProvidersTab providerConfigs={scan.providerConfigs} />;

    case ScanDetailsDrawerTab.Scope:
      return <ScopeTab scope={scan.scope} />;

    default:
      return null;
  }
};

export default ScanDetailsDrawerTabContent;
